import { useContext } from 'react'
import { LanguageContext } from './context'
import { enUs } from './en_us'
import { esMx } from './es_mx'
import { frCa } from './fr_ca'
import { type ILanguageKeys } from './interface'

const showMissingTranslations =
  import.meta.env.VITE_SHOW_MISSING_TRANSLATIONS === 'true'

export const Translate = (
  key: string,
  textReplacement?: Array<string | number>
): string => {
  const { selectedLanguage } = useContext(LanguageContext)

  const typedKey = key as keyof ILanguageKeys

  let translated = ''
  switch (selectedLanguage) {
    case 'en_US':
      translated = enUs[typedKey]
      break
    case 'es_MX':
      translated = esMx[typedKey] || ''
      break
    case 'fr_CA':
      translated = frCa[typedKey] || ''
      break
    default:
      translated = enUs[typedKey]
  }
  if (
    translated &&
    translated.indexOf('%') > -1 &&
    textReplacement !== undefined
  ) {
    for (let i = 0; i < textReplacement.length; i += 1) {
      translated = translated.replace('%', String(textReplacement[i]))
    }
  }
  if (showMissingTranslations && !translated) {
    return `TRANSLATION -> ${key}`
  }

  return !translated ? key : translated
}
